import Big from 'big.js';

import type { Validator } from '@personly/libs-types';

const validateText = (validator: Validator, value: string) => {
  if (validator.min && value.length < validator.min) return false;
  if (validator.max && value.length > validator.max) return false;
  if (
    validator.values &&
    validator.values.length > 0 &&
    !validator.values.includes(value)
  )
    return false;
  if (validator.regex && validator.regex.length > 0) {
    const rexp = new RegExp(validator.regex, 'i');
    if (!rexp.test(value)) return false;
  }

  return true;
};

const validateDate = (validator: Validator, value: Date) => {
  const inputYear = value.getUTCFullYear();
  const currentYear = new Date().getUTCFullYear();

  const min = currentYear + (validator.min || 0);
  const max = currentYear + (validator.max || 0);

  return inputYear >= min && inputYear <= max;
};

const validateNum = (validator: Validator, value: Big) => {
  if (!Number.isInteger(value.toNumber())) return false;
  if (validator.min && value.lt(validator.min)) return false;
  if (validator.max && value.gt(validator.max)) return false;

  return true;
};

const validateUrl = (validator: Validator, value: string) => {
  if (validator.max && value.length > validator.max) return false;
  if (validator.min && value.length < validator.min) return false;

  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

const validate = (
  validator: Validator,
  value: string | Date | number | Big | undefined | null
) => {
  if (validator.typeHandle === 'TEXT')
    return validateText(validator, value as string);

  if (validator.typeHandle === 'DATE')
    return validateDate(validator, value as Date);

  if (validator.typeHandle === 'NUMBER')
    return validateNum(validator, Big(value as string));

  if (validator.typeHandle === 'URL')
    return validateUrl(validator, value as string);

  throw new Error('Bad validator type specified.');
};

export default validate;
